export default __webpack_public_path__ + "static/media/logo-welcome.da54564d.webp";